import type { CommonSVGProps } from './helpers';

export const SunVector = (props: CommonSVGProps) => (
  <svg
    fill="none"
    height={38}
    width={38}
    {...props}
  >
    <path
      d="M35.5 19h-1.833M19 35.5v-1.833M4.333 19H2.5M19 4.333V2.5m11.733 28.233L29.45 29.45M7.267 30.733 8.55 29.45m0-20.9L7.267 7.267M29.45 8.55l1.283-1.283M26.333 19a7.333 7.333 0 1 0-14.667 0 7.333 7.333 0 0 0 14.667 0Z"
      stroke="#CF5933"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeOpacity={1}
      strokeWidth={3.667}
    />
  </svg>
);
